import React from 'react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/content';
const steps = ['One practice.', 'One intention.', 'One journal entry.', 'One closing.', 'Then repeat.'];
export function Author() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-68" data-mp="1wi8a4tc3e8c2">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[0.9fr_1.1fr]" data-id="element-69" data-mp="1rpf504cpoxzg">
        <div className="-mx-5 md:sticky md:top-8 md:mx-0" data-id="element-70" data-mp="25h3hw9usbqhh">
          <img src={images.author} alt="Helena Duarte holding a singing bowl" className="aspect-[4/5] w-full object-cover object-top md:rounded-3xl" loading="lazy" data-id="element-71" data-mp="25finck8h07jm" />
        </div>
        <div data-id="element-72" data-mp="2agpuqi6pb4pr">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600 sm:text-sm" data-id="element-73" data-mp="2ag6mjt6uruox">About the author</p>
          <h2 className="mt-3 font-display text-[32px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-74" data-mp="l2jpi8mb9lef">
            Hi, I’m <em className="text-brand-700" data-id="element-75" data-mp="g3zyvuwrvlfq">Helena Duarte</em>
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-76" data-mp="3gf5pq5tc48dx">
            <p data-id="element-77" data-mp="3kfg3i4ndc33c">For years, I studied different spiritual paths, energy practices, meditation and self-awareness tools.</p>
            <p data-id="element-78" data-mp="3pdzr09hm1mxt">
              And for a long time, I made a mistake I see constantly: <strong className="text-ink" data-id="element-79" data-mp="3u5hkkchb0l8r">I thought I needed to learn more.</strong>
            </p>
            <p data-id="element-80" data-mp="2zzkt1shhhs6">
              When I felt something wasn’t right, I searched for another technique. When I wanted to work with my energy,
              I searched for another ritual. When I discovered Apometry, I wanted to understand all of its laws and
              techniques before I even began practicing.
            </p>
            <p data-id="element-81" data-mp="gy685nzt3zdl">I ended up accumulating information. But when it was time to practice, the same question kept coming back:</p>
            <p className="font-display text-2xl font-bold italic text-brand-700" data-id="element-82" data-mp="2dtc4sdlwojoj">“What do I do now?”</p>
            <p data-id="element-83" data-mp="2iqufa8fkn6yn">
              That’s when I changed the way I approached my practice. Instead of trying to learn everything first, I
              started creating simple sequences:
            </p>
          </div>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-84" data-mp="3h4rmu3c0ci6g">
            {steps.map(s => <li key={s} className="rounded-full bg-brand-50 px-4 py-2 text-[15px] font-semibold text-brand-800" data-id="element-85" data-mp="3v03gs8ica4mb">
                {s}
              </li>)}
          </ul>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-86" data-mp="8tf1ja783sfe">
            <p data-id="element-87" data-mp="3v3pqtxdb7uj">
              That’s how the <strong className="text-ink" data-id="element-88" data-mp="3tslyu3xa03f">7D Apometry Protocol™</strong> was born. I didn’t create it to
              replace a complete professional Apometry training — I created it to help someone interested in Apometry turn
              that interest into an organized personal practice.
            </p>
            <p data-id="element-89" data-mp="rj4s1l3yds1i">
              Everything revolves around one simple idea: <strong className="text-ink" data-id="element-90" data-mp="mnpfqxllg477">15 minutes a day.</strong> You
              don’t need to learn everything today. You need to begin.
            </p>
            <p data-id="element-91" data-mp="1b6zknlvs1uhy">And I want you to finish these seven days being able to say:</p>
            <p className="rounded-2xl bg-cream p-5 font-display text-xl font-bold italic leading-snug text-ink" data-id="element-92" data-mp="1b4wwz8i3kdge">
              “Now I know exactly how to begin my practice.”
            </p>
            <p className="font-display text-lg font-bold text-brand-800" data-id="element-93" data-mp="11b6b8bdcuh4e">— Helena Duarte</p>
          </div>
          <CtaButton label="I want to begin with Helena" className="mt-8" data-id="element-94" data-mp="nfu4f5lxd074" />
        </div>
      </div>
    </section>;
}